// extracted by mini-css-extract-plugin
export default {"Lesson":"Lesson_Lesson__epxDL"};